import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DialogInputWithId, IDialogComponent} from "../../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../../common/dialog/dialogWithInput";
import {DialogModule} from "../../../../../common/dialog/dialog.module";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BaseView} from "../../../../../core/view/base.view";
import {DocumentSummaryModel} from "../../../../common/api/model/documentSummary.model";
import {CardModule} from "../../../../../core/component/card/card.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {MatRadioModule} from "@angular/material/radio";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {SelectElementV2} from "../../../../../../components/common/select/selectElementV2";
import {SelectFilterV2Component} from "../../../../../../components/common/select-filter-v2/select-filter-v2.component";
import {
  SmsContentInputModule
} from "../../../../../communication/sms/api/component/sms-content-input/sms-content-input.module";
import {
  CommunicationContentEditorModule
} from "../../../../../communication/common/api/component/communication-content-editor/communication-content-editor.module";
import {EmailInputModule} from "../../../../../common/email/component/email-input/email-input.module";
import {PhoneInputModule} from "../../../../../common/phone/component/phone-input/phone-input.module";
import {PhoneSavePayload} from "../../../../../common/phone/payload/phoneSave.payload";
import {InputTextModule} from "../../../../../core/component/input-text/input-text.module";
import {DocumentSendSignUrlActionService} from "../../../../common/api/service/documentSendSignUrlAction.service";

@Component({
  selector: 'app-document-signature-send-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, CardModule, FormFieldModule, MatRadioModule, ButtonModule, SelectFilterV2Component, SmsContentInputModule, CommunicationContentEditorModule, EmailInputModule, PhoneInputModule, InputTextModule],
  templateUrl: './document-signature-send-dialog.component.html',
  providers: [
    DocumentSendSignUrlActionService
  ]
})
export class DocumentSignatureSendDialogComponent extends BaseView implements IDialogComponent<DocumentSummaryModel, string>, OnInit{
  dialog: DialogWithInput<DocumentSummaryModel, string>;
  typeElements: SelectElementV2<string> [] = [
      new SelectElementV2<string>('email', 'E-mail', 'email'),
      new SelectElementV2<string>('sms', 'Sms', 'sms')
  ]
  type: 'email' | 'sms' = 'email';
  formGroup: FormGroup;
  phoneNumber: PhoneSavePayload;

  constructor(private formBuilder: FormBuilder,
              public service: DocumentSendSignUrlActionService) {
    super();
    this.formGroup = this.formBuilder.group({
      id: this.formBuilder.control(undefined, Validators.required),
      type: this.formBuilder.control('email', Validators.required),
      content: this.formBuilder.control(undefined, Validators.required),
    });

  }

  ngOnInit() {
    this.typeChanged();
    this.phoneNumber = PhoneSavePayload.fromPhoneModel(this.dialog.input.partner?.mobilePhone);
    if (! this.phoneNumber) {
      this.phoneNumber = PhoneSavePayload.fromPhoneModel(this.dialog.input.partner?.phone);
    }
    if (! this.phoneNumber) {
      this.phoneNumber = PhoneSavePayload.fromPhoneModel(this.dialog.input.partner?.officePhone);
    }

    this.formGroup.patchValue({
      id: this.dialog.input.id
    });
  }

  typeChanged() {
    this.formGroup.removeControl('email');
    this.formGroup.removeControl('sms');
    const type = this.formGroup.get('type').value;
    let content = 'Bonjour <br/>Veuillez cliquer sur le lien suivant pour signer votre document: <a href="' + this.dialog.input.signUrl + '">|lienSignatureDocument|</a><br/><br/>Cordialement,<br/>Votre podologue.';
    if (type == 'sms') {
      content = 'Veuillez signer document: |lienSignatureDocument|. Votre podologue.';
      this.formGroup.addControl(
          'sms',
          this.formBuilder.group({
            to : this.formBuilder.group({})
          })
      );
    } else {
      this.formGroup.addControl(
          'email',
          this.formBuilder.group({
            to: this.formBuilder.control(this.dialog.input.partner?.email, Validators.required),
            subject: this.formBuilder.control('Vous avez un document à signer chez votre podologue')
          })
      );
    }
    this.formGroup.patchValue({
      content: content.replace('|lienSignatureDocument|', this.dialog.input.signUrl)
    });
  }

  send() {
    this.service.executeAction(this.formGroup.value)
        .then(()=> {
          this.toastControl.presentConfirmation('Le lien a été envoyé');
          this.dialog.close();
        })
        .catch((e) => this.toastControl.presentError(e));
  }
}
